import { computed } from 'mobx';
import VoucherPurchases from 'app/dataStores/voucherPurchases';
import TicketBaseViewStore from '../common/view';

class VouchersViewStore extends TicketBaseViewStore {
  purchaseDataStore = new VoucherPurchases(this.activeObject.facility);

  @computed get priceRanges() {
    const values = this.activeObject.fixed_price_choices
      ? this.activeObject.fixed_price_choices
      : [];
    return values.map((price) => parseFloat(price.trim()));
  }
  @computed get hasNoFixedValues() {
    return !this.priceRanges.length;
  }
  @computed get defaultPrice() {
    return this.priceRanges ? this.priceRanges[0] : 0;
  }
}

export default new VouchersViewStore();
